const CHANGE_SHIPPING_COUNTRY_SHOW = 'modules/manageChangeShippingCountrySelector/SHOW';
const CHANGE_SHIPPING_COUNTRY_HIDE = 'modules/manageChangeShippingCountrySelector/HIDE';

const reducer = (state = false, action) => {
  switch (action.type) {
    case CHANGE_SHIPPING_COUNTRY_SHOW:
      return true;
    case CHANGE_SHIPPING_COUNTRY_HIDE:
      return false;
    default:
      return state;
  }
};

const showChangeShippingCountry = () => ({ type: CHANGE_SHIPPING_COUNTRY_SHOW });
const hideChangeShippingCountry = () => ({ type: CHANGE_SHIPPING_COUNTRY_HIDE });

export { reducer as default, showChangeShippingCountry, hideChangeShippingCountry };
